import { createLogic } from 'redux-logic'
import * as type from '../constants/firmware'
import {
  saveAvailableFirmwares, setFirmwareStatus, syncSentFirmware,
} from '../actions/firmware'
import firmwareChannel from '../api/firmwareChannel'

const subscribeFirmwareChannelLogic = createLogic({
  type: type.SYNC_FIRMWARE_CHANNEL,
  cancelType: type.SYNC_CANCEL_FIRMWARE_CHANNEL,
  latest: true,
  warnTimeout: 0,

  process(_, dispatch) {
    firmwareChannel({
      request: () => {
        dispatch(syncSentFirmware())
      },
      response: (data) => {
        if (data.firmwares) {
          const sortedFirmwares = data.firmwares.sort((a, b) => {
            const [nameA, versionA] = a.split('_')
            const [nameB, versionB] = b.split('_')

            if (nameA !== nameB) {
              return nameA.localeCompare(nameB)
            }

            return parseInt(versionB.replace(/\D/g, ''), 10)
              - parseInt(versionA.replace(/\D/g, ''), 10)
          })
          window.store.dispatch(saveAvailableFirmwares(sortedFirmwares))
        }
        if (data.firmware_status) {
          window.store.dispatch(setFirmwareStatus(data.firmware_status))
        }
      },
    })
  },
})

export default subscribeFirmwareChannelLogic
